/* eslint-disable react-hooks/exhaustive-deps */
// wijmo

import React, { useContext, useEffect, useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import TextInput from "../../../components/InputWrapper/TextInput"
import LocalAlertComponent from "../../../components/LocalAlertComponent"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { ModalOuter, TModalTypes } from "../../../components/Modal/ModalOuter"
import Spinner from "../../../components/Spinner"
import dayjs from "dayjs"
import ComboBox from "../../../components/ComboBox"
import { showInfoToast } from "../../../components/CustomToast"
import { useDispatch } from "react-redux"
import DateInput from "../../../components/InputWrapper/DateInput"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { AppDispatch } from "../../.."
import { TApiResponse } from "../../../service/TApiResponse"
import { setAlerts } from "../../../globalStore/alertStore"
import BusyoService from "../../../service/master/busyo/busyoService"
import KubunService from "../../../service/master/kubun/kubunService"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import { FunctionContext } from "../../../components/Context"
import TextAreaInput from "../../../components/InputWrapper/TextAreaInput"
import SyainSyozokuHenkouListService from "../../../service/master/syainSyozoku/syainSyozokuService"
import { 区分分類コード } from "../../../constant/enum/codes"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"

/**
 * 社員所属変更一覧変更モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const SyozokuChangeModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    社員ID: number
    登録更新: "登録" | "更新"
  }
> = (props) => {
  //#region [state]
  // 検索用
  const pageSearch = useContext(FunctionContext)

  //アラート制御
  const disPatch: AppDispatch = useDispatch()

  // 固定
  const [社員コード, set社員コード] = useState<string>("")
  const [社員氏名, set社員氏名] = useState<string>("")
  const [現在_社員区分コード, set現在_社員区分コード] = useState<string>("")
  const [現在社員区分名称, set現在社員区分名称] = useState<string>("")
  const [現在所属開始日, set現在所属開始日] = useState<string>("")
  const [現在部所, set現在部所] = useState<string>("")
  const [現在所属部所ID, set現在所属部所ID] = useState<number>(0)

  // state
  const [異動日, set異動日] = useState<string | undefined>("")
  const [備考, set備考] = useState<string>("")
  const [異動先所属部所ID, set異動先所属部所ID] = useState<number | undefined>(
    0
  )
  const [削除フラグ, set削除フラグ] = useState<number | undefined>(0)
  const [更新日時, set更新日時] = useState<string | undefined>("")

  // ComboBoxState
  // 部所ComboBox
  const [部所コード, set部所コード] = useState<string | undefined>("")
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [部所isLoadEnded, set部所isLoadEnded] = useState<boolean>(false)

  // 社員区分ComboBox
  const [次社員区分コード, set次社員区分コード] = useState<string | undefined>(
    ""
  )
  const [社員区分ComboBox, set社員区分ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()
  const [社員区分IsLoadEnded, set社員区分IsLoadEnded] = useState<boolean>(false)

  // init
  const [initialDataSetFlag, setInitialDataSetFlag] = useState(false)

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)
  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]
  /**
   * データ取得
   */
  const getData = async (id: number, signal: AbortSignal) => {
    const service = new SyainSyozokuHenkouListService()
    //アラートクリア
    setAlertSource("")
    try {
      const res = await service.getSyozoku(id)
      if (res.data) {
        // 現在情報
        set社員コード(res.data.社員コード)
        set社員氏名(res.data.社員氏名)
        set現在_社員区分コード(res.data.現在_社員区分コード)
        set現在社員区分名称(res.data.現在_社員区分名称)
        set現在所属開始日(res.data.現在_所属開始日)
        set現在部所(res.data.現在_部所名)
        set現在所属部所ID(res.data.現在_所属部所ID)

        // 異動先情報
        set異動日(res.data.異動先_所属開始日)
        set部所コード(res.data.異動先_部所コード)
        set次社員区分コード(res.data.異動先_社員区分コード)
        set備考(res.data.異動先_備考)
        set異動先所属部所ID(res.data.異動先_所属部所ID)

        set削除フラグ(res.data.異動先_削除フラグ)
        set更新日時(res.data.異動先_更新日時)
      }
    } catch (error) {
      setAlertSource(error)
    }
  }

  // TODO:登録処理

  const beforeSubmit = () => {
    // TODO:バリデーションチェック

    setIsConfirmModalShow(true)
  }

  //TODO:PUTのみAPIで処理
  const submit = async () => {
    try {
      let data = {
        現在_所属部所ID: 現在所属部所ID,
        現在_社員区分コード: 現在_社員区分コード,
        異動先_所属部所ID: 異動先所属部所ID ?? 0,
        異動先_部所コード: 部所コード ?? "",
        異動先_所属開始日: 異動日 ?? "",
        異動先_社員区分コード: 次社員区分コード ?? "",
        異動先_備考: 備考 ?? "",
        更新日時,
        削除フラグ,
      }

      const service = new SyainSyozokuHenkouListService()

      let res: TApiResponse<boolean>

      if (props.登録更新 === "更新") {
        //異動先データが存在する場合更新
        res = await service.putSyozoku(props.社員ID.toString(), data)
      } else {
        //異動先データが存在しない場合新規登録
        res = await service.postSyozoku(props.社員ID.toString(), data)
      }

      disPatch(setAlerts(res))
      if (res) {
        props.setIsShow(false)
        showInfoToast(
          `異動先の乗務員所属マスタの${
            props.社員ID ? "更新" : "登録"
          }が完了しました。`
        )
        pageSearch()
      }
    } catch (error) {
      disPatch(setAlerts(error))
      setAlertSource(error)
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  //#endregion

  //#region [effect]

  useEffect(() => {
    if (!部所ComboBox) return

    if (props.isShow) {
      Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
        set部所ItemSource(部所ListRes.data)

        setInitialDataSetFlag(true)
      })
      // setIsSpinnerShow(false)
    } else {
      // 非表示時中身を空にして閉じる
      set社員コード("")
      set社員氏名("")
      set現在社員区分名称("")
      set現在所属開始日("")
      set現在部所("")
      set異動日("")
      set部所コード("")
      set備考("")
      set削除フラグ(0)
      set更新日時("")
      set削除フラグ(0)
      set削除フラグ(0)
      set現在所属部所ID(0)
      set次社員区分コード("")
      set現在所属部所ID(0)

      setIsSpinnerShow(true)
    }
  }, [props.isShow, 部所ComboBox])

  useEffect(() => {
    if (!社員区分ComboBox) return

    if (props.isShow) {
      Promise.all([new KubunService().getList({})]).then(([区分マスタRes]) => {
        set区分ItemSource(区分マスタRes.data)

        setInitialDataSetFlag(true)
      })
      // setIsSpinnerShow(false)
    } else {
      // 非表示時中身を空にして閉じる
      set社員コード("")
      set社員氏名("")
      set現在社員区分名称("")
      set現在所属開始日("")
      set現在部所("")
      set異動日("")
      set部所コード("")
      set備考("")
      set削除フラグ(0)
      set更新日時("")
      set削除フラグ(0)
      set削除フラグ(0)
      set現在所属部所ID(0)
      set次社員区分コード("")
      set現在所属部所ID(0)

      setIsSpinnerShow(true)
    }
  }, [props.isShow, 部所ComboBox])

  useEffect(() => {
    if (initialDataSetFlag) {
      const abortController = new AbortController()
      getData(props.社員ID, abortController.signal).finally(() => {
        setInitialDataSetFlag(false)
        setIsSpinnerShow(false)
      })
    } else {
      setIsSpinnerShow(false)
    }
  }, [initialDataSetFlag])

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "所属変更"}
      setIsShow={props.setIsShow}
      size={"lg"}
      footer={
        <>
          {props.登録更新 === "更新" && (
            //異動先の所属部所IDが存在する場合
            <Button
              type="submit"
              variant="caution"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                // 削除する為、削除フラグを制御
                set削除フラグ(1)
                beforeSubmit()
              }}>
              削除
            </Button>
          )}
          <Button
            type="submit"
            variant="waiting"
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              // 更新する為、削除フラグを制御
              set削除フラグ(0)
              beforeSubmit()
            }}>
            更新
          </Button>
        </>
      }>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid className="register-form">
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <ul className="list-cmn">
                <li className="list-cmn  d-flex">
                  <div className="d-flex">
                    <TextInput
                      style={{ width: "6rem" }}
                      id="社員コード"
                      name="社員コード"
                      value={社員コード}
                      isReadOnly={true}
                      setValue={() => {}}
                      placeholder="社員CD"
                    />
                    <TextInput
                      style={{ width: "12rem" }}
                      id="社員氏名"
                      name="社員氏名"
                      value={社員氏名}
                      isReadOnly={true}
                      setValue={() => {}}
                      placeholder="氏名"
                    />
                    <TextInput
                      style={{ width: "12rem" }}
                      id="現在社員区分名称"
                      name="現在社員氏名"
                      value={現在社員区分名称}
                      isReadOnly={true}
                      setValue={() => {}}
                      placeholder="現社員区分"
                    />
                  </div>
                </li>
                <li className="list-cmn d-flex">
                  <div className="d-flex w-6rem">
                    <TextInput
                      id="現在所属開始日"
                      name="現在所属開始日"
                      value={dayjs(現在所属開始日!).format("YYYY/MM/DD")}
                      isReadOnly={true}
                      setValue={() => {}}
                      placeholder="現在所属開始日"
                    />
                  </div>
                  <div className="d-flex">
                    <TextInput
                      style={{ width: "20rem" }}
                      id="現在部所"
                      name="現在部所"
                      value={現在部所}
                      isReadOnly={true}
                      setValue={() => {}}
                      placeholder="現在部所"
                    />
                  </div>
                </li>
              </ul>
            </Col>
          </Row>
          <MasterRegisterFormRow label="異動日" isRequired={true}>
            <div className="w-10rem">
              <DateInput
                id="異動日"
                // min={yokueigyobi}
                isRequired
                value={異動日}
                setValue={(v) => {
                  set異動日(v!)
                }}></DateInput>
            </div>
          </MasterRegisterFormRow>
          <MasterRegisterFormRow label="異動先部所" isRequired={true}>
            <ComboBox.Busyo
              isEmpty={true}
              isRequired={true}
              itemsSource={部所ItemSource}
              isLoadEnded={部所isLoadEnded}
              setIsLoadEnded={set部所isLoadEnded}
              selectedValue={部所コード}
              setSelectedValue={(v) => {
                set部所コード(v!)
              }}
              ComboBox={部所ComboBox}
              setComboBox={set部所ComboBox}></ComboBox.Busyo>
          </MasterRegisterFormRow>
          <MasterRegisterFormRow label="次社員区分" isRequired={true}>
            <ComboBox.Kubun
              isEmpty={true}
              分類コード={区分分類コード.社員_乗務員.社員区分}
              isRequired={true}
              itemsSource={区分ItemSource}
              isLoadEnded={社員区分IsLoadEnded}
              setIsLoadEnded={set社員区分IsLoadEnded}
              selectedValue={次社員区分コード}
              setSelectedValue={(v) => {
                set次社員区分コード(v!)
              }}
              ComboBox={社員区分ComboBox}
              setComboBox={set社員区分ComboBox}></ComboBox.Kubun>
          </MasterRegisterFormRow>
          <MasterRegisterFormRow label="備考" isRequired={false}>
            <TextAreaInput
              style={{ width: "30rem" }}
              id="備考"
              name="備考"
              value={備考}
              setValue={set備考}></TextAreaInput>
          </MasterRegisterFormRow>
        </form>
      </Container>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </ModalOuter>
  )
}

export default SyozokuChangeModal
